const FACTORY_STANDALONE_ADDON_PRODUCT_IDS = new Set([360]);

export function getOptionsKeyValue(product, key) {
	if (!Array.isArray(product?.product_options)) return false;

	for (const option of product.product_options) {
		if (typeof option.value !== 'string' || !option.value.includes(key)) {
			continue;
		}

		try {
			const value = JSON.parse(option.value)[key];
			if (value) return value;
		} catch (e) {
			continue;
		}
	}

	return false;
}

export function isFactoryStandaloneAddonProduct(product) {
	return FACTORY_STANDALONE_ADDON_PRODUCT_IDS.has(
		Number(product?.bc_item_id ?? product?.product_id),
	);
}

export function shouldNestAddonLineItem(lineItem) {
	return Boolean(
		lineItem?.parentId && !isFactoryStandaloneAddonProduct(lineItem),
	);
}
